// Marketing · Landing pages (montado en /marketing/landings/*): lista, detalle y editor por bloques.
import type { JSX } from "react";
import { Route, Routes } from "react-router-dom";
import { LandingList } from "./landings/LandingList.tsx";
import { LandingDetail } from "./landings/LandingDetail.tsx";
import { LandingEditor } from "./landings/LandingEditor.tsx";

export function MktLandings(): JSX.Element {
  return (
    <Routes>
      <Route index element={<LandingList />} />
      <Route path=":id" element={<LandingDetail />} />
      <Route path=":id/editor" element={<LandingEditor />} />
    </Routes>
  );
}
